import { Badge, Box, Card, FlexGrid, StackView, Spacer, StackWrap } from '@telus-uds/components-web'
import type { FilterCard, TagProps } from './CardFilter'

export const matchTags = (card: FilterCard, lowerSearch: string): boolean =>
  Array.isArray(card.tags) && card.tags.some((tag) => tag.label.toLowerCase().includes(lowerSearch))

export const matchSearchTerms = (card: FilterCard, lowerSearch: string): boolean =>
  !!card.searchTerms &&
  card.searchTerms
    .split(',')
    .map((t) => t.trim().toLowerCase())
    .some((t) => t.includes(lowerSearch))

const renderTagBadges = (tags?: TagProps[], hasGutter?: boolean) => {
  if (!tags?.length) return null

  return (
    <Box testID="tag-badges-wrapper" horizontal={hasGutter === false ? 0 : 3}>
      <StackWrap direction="row" space={1}>
        {tags.map((tag) => (
          <Badge testID={`tag-badge-${tag.id}`} key={`tag-badge-${tag.id}`} variant={{ outline: true }}>
            {tag.label}
          </Badge>
        ))}
      </StackWrap>
    </Box>
  )
}

export const renderCard = (card: FilterCard, equalCardHeight?: boolean) => {
  const size: { xs: number; md: number; lg: number } = { xs: 12, md: 6, lg: 4 }

  return (
    <FlexGrid.Col key={card.id} {...size} testID={card.id} flex={equalCardHeight}>
      <Card
        tokens={{
          contentFlexGrow: 1,
          contentJustifyContent: 'space-between',
        }}
        variant={{ background: card.background, padding: 'narrow' }}
      >
        <StackView>
          {card.content}
          {renderTagBadges(card.tags, card.hasGutter)}
        </StackView>
      </Card>
      <Spacer space={5} />
    </FlexGrid.Col>
  )
}
